import { makeStyles } from '@mui/styles';

const useNoResultsStyles = makeStyles({
	searchText: {
		color: '#003C82',
		fontWeight: 'bold',
	},
	spanText: {
		fontSize: 16,
	},
});

export default useNoResultsStyles;
